import "./polyfills/modern";
import { App } from "Core/App";

window._odepApp = new App(); // initialize App
